import type { SVGProps } from "react";

export default function DangerPentagonIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.333 6.45898V10.834"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9 7.14937V12.8493C17.9 13.7827 17.4 14.6493 16.5917 15.1243L11.6417 17.9827C10.8333 18.4493 9.83333 18.4493 9.01667 17.9827L4.06663 15.1243C3.2583 14.6577 2.7583 13.791 2.7583 12.8493V7.14937C2.7583 6.21604 3.2583 5.34934 4.06663 4.87434L9.01667 2.01602C9.825 1.54935 10.825 1.54935 11.6417 2.01602L16.5917 4.87434C17.4 5.34934 17.9 6.20771 17.9 7.14937Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.333 13.5V13.5833"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
